import { IsInAuthor, ShowSettingsAtom } from "../state/ui";
import { useRecoilState, useRecoilValue } from "recoil";

import { useEffect } from "react";

function useReaderSettings() {

    const [showSettings, setShowSettings] = useRecoilState(ShowSettingsAtom);
    const isInAuthor = useRecoilValue(IsInAuthor)

    useEffect(() => {
        if (isInAuthor) return
        const handleTouch = (event: TouchEvent) => {
            if (event.touches.length === 3) {
                setShowSettings(!showSettings);
            }
        }
        document.addEventListener("touchstart", handleTouch)
    }, [showSettings, setShowSettings, isInAuthor]);



    useEffect(() => {
        if (isInAuthor) return
        const settingsKeys = {
            s: false,
            e: false,
            t: false,
        };


        const triggerShowSettings = (e: KeyboardEvent) => {

            if (e.key !== "s" && e.key !== "e" && e.key !== "t") {
                settingsKeys.s = false;
                settingsKeys.e = false;
                settingsKeys.t = false;

            }
            if (e.key === "s") {
                settingsKeys.s = true;
            }
            if (e.key === "e") {
                settingsKeys.e = true;
            }
            if (e.key === "t") {
                settingsKeys.t = true;
            }
            if (settingsKeys.s && settingsKeys.e && settingsKeys.t) {
                ////console.log("toggle");
                setShowSettings(!showSettings);
                settingsKeys.s = false;
                settingsKeys.e = false;
                settingsKeys.t = false;
            }


        };
        window.addEventListener("keydown", triggerShowSettings);
        return () => window.removeEventListener("keydown", triggerShowSettings);
    }, [showSettings, setShowSettings, isInAuthor]);



}

export default useReaderSettings